import * as React from "react";
import { PanelLeft16Regular } from "@fluentui/react-icons";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { SideDrawer } from "./Generic/SideMenu/SideDrawer";
import { AssetTreeStatus, useAssetTree } from "./AssetTreeShared";
import { AssetTree } from "./AssetTree";
import { createAssetTreeControls } from "./AssetTreeControls";
import PinnedAssetsList from "./PinnedAssetsList";

interface AssetDrawerProps {
    className?: string;
    startOpen: boolean;
}

export default function AssetDrawer(props: AssetDrawerProps) {
    const assetTree = useAssetTree();
    const asset = assetTree.status === "ready" ? assetTree.asset : undefined;
    const cards = useAppSelector((state) => state.dashboardSlice.cards);
    const dispatch = useAppDispatch();

    // Registered here rather than in the tree, so the tour can add and remove its demo cards while the drawer is closed.
    React.useEffect(() => {
        (window as any).assetTreeControls = createAssetTreeControls(asset, dispatch, cards);
        return () => {
            delete (window as any).assetTreeControls;
        };
    }, [asset, dispatch, cards]);

    return (
        <SideDrawer
            title="Assets"
            startOpen={props.startOpen}
            className={props.className}
            dataTour="asset-drawer"
            controlsKey="assetDrawerControls"
            collapsedIcon={<PanelLeft16Regular className="absolute top-1 left-1" />}
        >
            {asset ? (
                <>
                    <PinnedAssetsList asset={asset} cards={cards} />
                    <div role="separator" className="mx-1 my-2 h-px shrink-0 bg-[var(--colorNeutralStroke2)]" />
                    <AssetTree asset={asset} cards={cards} />
                </>
            ) : (
                <AssetTreeStatus status={assetTree.status === "error" ? "error" : "loading"} />
            )}
        </SideDrawer>
    );
}
